import { render, staticRenderFns } from "./Nomsg.vue?vue&type=template&id=0b40d818&scoped=true"
var script = {}
import style0 from "./Nomsg.vue?vue&type=style&index=0&id=0b40d818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40d818",
  null
  
)

export default component.exports